var React = require('react');

function LocationStart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.0001 12.0001C22.0001 17.523 17.523 22.0001 12.0001 22.0001C6.47727 22.0001 2.00012 17.523 2.00012 12.0001C2.00012 6.47727 6.47727 2.00012 12.0001 2.00012C17.523 2.00012 22.0001 6.47727 22.0001 12.0001ZM6.00012 12.0001C6.00012 15.3138 8.68641 18.0001 12.0001 18.0001C15.3138 18.0001 18.0001 15.3138 18.0001 12.0001C18.0001 8.68641 15.3138 6.00012 12.0001 6.00012C8.68641 6.00012 6.00012 8.68641 6.00012 12.0001Z","fill":"#0088BF","key":1})]);
}

LocationStart.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = LocationStart;

LocationStart.default = LocationStart;
